if (!customElements.get('pws-mobile-slider')) {
  customElements.define('pws-mobile-slider', class extends HTMLElement {
    connectedCallback() { this.startFrame=requestAnimationFrame(()=>this.initialize()); }
    initialize() {
      this.track=this.querySelector('[data-pws-track]'); this.dots=this.querySelector('[data-pws-dots]');
      if(!this.track||!this.dots) return;
      this.slides=Array.from(this.track.children); this.media=matchMedia('(max-width:749px)');
      this.abort=new AbortController(); const signal=this.abort.signal;
      this.dots.replaceChildren();
      this.buttons=this.slides.map((slide,index)=>{
        const button=document.createElement('button'); button.type='button'; button.className='pws-mobile-slider__dot';
        button.setAttribute('aria-label','Show slide '+(index+1)+' of '+this.slides.length);
        if(this.track.id)button.setAttribute('aria-controls',this.track.id);
        button.addEventListener('click',()=>this.go(index),{signal});this.dots.append(button);return button;
      });
      this.onScroll=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
      this.track.addEventListener('scroll',this.onScroll,{passive:true,signal});
      this.track.addEventListener('keydown',event=>{
        if(event.target!==this.track||!this.media.matches)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.go(this.active+(event.key==='ArrowRight'?1:-1));}
      },{signal});
      this.addEventListener('shopify:block:select',event=>{const i=this.slides.findIndex(s=>s===event.target||s.contains(event.target));if(i>=0&&this.media.matches)this.go(i,true);},{signal});
      this.onMedia=()=>this.update();this.media.addEventListener('change',this.onMedia);
      if('ResizeObserver'in window){this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);}
      this.classList.add('pws-mobile-slider--ready');this.active=0;this.update();
    }
    go(index,instant=false) {
      if(!this.slides.length)return;
      const i=Math.max(0,Math.min(index,this.slides.length-1));
      const left=this.slides[i].offsetLeft-this.slides[0].offsetLeft;
      this.track.scrollTo({left,behavior:instant||matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
    update() {
      if(!this.media)return;
      const mobile=this.media.matches;const overflow=this.track.scrollWidth>this.track.clientWidth+2;
      const show=mobile&&overflow&&this.slides.length>1;
      this.dots.hidden=!show;this.toggleAttribute('data-sliding',show);
      if(show)this.track.setAttribute('tabindex','0');else this.track.removeAttribute('tabindex');
      const bounds=this.track.getBoundingClientRect();const center=bounds.left+this.track.clientWidth/2;
      let distance=Infinity,index=0;
      this.slides.forEach((slide,i)=>{const r=slide.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-center);if(d<distance){distance=d;index=i;}});
      this.active=index;this.buttons.forEach((b,i)=>{if(i===index)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);cancelAnimationFrame(this.frame);
      if(this.abort)this.abort.abort();if(this.resize)this.resize.disconnect();
      if(this.media&&this.onMedia)this.media.removeEventListener('change',this.onMedia);
    }
  });
}
if(!customElements.get('pws-business-details')){
  customElements.define('pws-business-details',class extends HTMLElement{
    connectedCallback(){this.startFrame=requestAnimationFrame(()=>{this.details=this.querySelector('details');if(!this.details)return;this.media=matchMedia('(max-width:749px)');this.change=()=>{this.details.open=!this.media.matches;};this.media.addEventListener('change',this.change);this.change();});}
    disconnectedCallback(){cancelAnimationFrame(this.startFrame);if(this.media&&this.change)this.media.removeEventListener('change',this.change);}
  });
}
